import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { Box } from "@mui/material";
import { CountryService } from "../../../services/common/CountryService";
import { IAppState } from "../../../store/reducers";
import { useNavigateToLogout } from "../../../common/Common";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

interface IWSIBCodeRateInfoSetupFieldsPanel {
wsibCodeSetupDDL:any,
// wsibCodeRateProvinceDDL:any,
onProvinceSelectionChangeHandler: (params: any) => void;
setIsLoading: (value: boolean) => void;
}
const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: (data) => {
			return CountryService.getCountryDDL();
		},
		refetchOnWindowFocus: false,
	});
export const WSIBCodeRateInfoSetupFieldsPanel: FC<
	IWSIBCodeRateInfoSetupFieldsPanel
> = ({ wsibCodeSetupDDL ,  onProvinceSelectionChangeHandler, setIsLoading
	// wsibCodeRateProvinceDDL
}) => {
	const { data: countryDDL } = useGetCountryDDL();
	const navigateToLogout = useNavigateToLogout();
	const [provinceDDL, setProvinceDDL] = useState<any>(undefined);
	useEffect(() => {
		if (countryDDL && Array.isArray(countryDDL)) {
			const canada = countryDDL.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				(async () => {
					try {
						setIsLoading(true)
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						setProvinceDDL(response);
					} catch (err) { } finally {setIsLoading(false) }
				})();
			}
		}
	}, [countryDDL])
	return (
		<Box>
			
			<EnhancedDropDownRHFWithLabel 
				testId={"province-id"}
				selectName={"provinceId"}
				items={provinceDDL ?? []}
				label={"Province"}
				onSelectionChangeHandler={onProvinceSelectionChangeHandler}

			/>
			<EnhancedDropDownRHFWithLabel 
				testId={"codeId"}
				selectName={"codeId"}
				items={wsibCodeSetupDDL ?? []}
				label={"Code"}
			/>
			<RHookFormNumberFieldWithLabel id={"rate"} testId={"rate"} label={"Rate %"} />
			
			<RHookFormDatePicker label={"Effective Date"} testId={"effective-date"} name={"effectiveDate"} />
			<RHookFormDatePicker label={"End Date"} testId={"end-date"} name={"endDate"} />
		</Box>
	);
};
